module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.show) ? _c('div', {
    staticClass: "modal-backdrop fade show",
    staticStyle: {
      "background-color": "rgba(0, 0, 0, 0.6)",
      "backdrop-filter": "blur(4px)"
    },
    on: {
      "click": _vm.handleBackdropClick
    }
  }) : _vm._e(), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "email-container show",
    attrs: {
      "id": "email-validation-modal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-header modal-info"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('i', {
    staticClass: "icon-envelope-check"
  }), _vm._v("\n          Validar " + _vm._s(_vm.title) + "\n        ")]), _vm._v(" "), (_vm.allowClose) ? _c('button', {
    staticClass: "close",
    staticStyle: {
      "position": "absolute",
      "right": "15px",
      "top": "15px",
      "color": "white",
      "opacity": "0.8",
      "font-size": "28px",
      "font-weight": "bold",
      "background": "none",
      "border": "none",
      "cursor": "pointer"
    },
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(_vm.loadingChannels) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('div', {
    staticClass: "loading-spinner"
  }), _vm._v(" "), _c('p', {
    staticClass: "loading-text"
  }, [_vm._v("Carregando...")])]) : _vm._e(), _vm._v(" "), (_vm.step === 'channel-selection' && !_vm.loadingChannels) ? _c('div', {
    staticClass: "channel-selection-step"
  }, [_c('h3', {
    staticClass: "channel-title"
  }, [_vm._v("Como gostaria de ser notificado?")]), _vm._v(" "), _c('p', {
    staticClass: "channel-subtitle"
  }, [_vm._v("\n            Atenção: Verifique se você tem acesso ao e-mail ou telefone\n            cadastrado. Caso não tenha, entre em contato com a Central de\n            Relacionamento.\n          ")]), _vm._v(" "), (_vm.channels.length === 0) ? _c('div', {
    staticClass: "no-channels"
  }, [_c('p', {
    staticClass: "error-message"
  }, [_vm._v("\n              Nenhuma opção de notificação disponível no momento. Entre em\n              contato com a Central de Relacionamento.\n            ")])]) : _c('div', {
    staticClass: "channel-options"
  }, _vm._l((_vm.channels), function(channel) {
    return _c('div', {
      key: channel.value,
      staticClass: "channel-option",
      class: {
        'channel-option-selected': _vm.selectedChannel === channel.value,
      },
      on: {
        "click": function($event) {
          return _vm.selectChannel(channel.value)
        }
      }
    }, [_c('div', {
      staticClass: "channel-icon"
    }, [_c('i', {
      class: channel.icon
    })]), _vm._v(" "), _c('span', {
      staticClass: "channel-label"
    }, [_vm._v(_vm._s(channel.label))]), _vm._v(" "), _c('div', {
      staticClass: "channel-radio"
    }, [_c('div', {
      staticClass: "radio-button",
      class: {
        'radio-button-selected':
        _vm.selectedChannel === channel.value,
      }
    })])])
  }), 0), _vm._v(" "), (_vm.channelErrorMessage) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v("\n            " + _vm._s(_vm.channelErrorMessage) + "\n          ")]) : _vm._e(), _vm._v(" "), (!_vm.loadingChannels && _vm.channels.length > 0) ? _c('button', {
    staticClass: "btn btn-confirm",
    attrs: {
      "disabled": !_vm.selectedChannel || _vm.isProcessing
    },
    on: {
      "click": _vm.handleConfirmChannel
    }
  }, [_vm._v("\n            Confirmar\n          ")]) : _vm._e(), _vm._v(" "), (_vm.allowClose) ? _c('button', {
    staticClass: "btn-cancel-link",
    attrs: {
      "disabled": _vm.isProcessing
    },
    on: {
      "click": _vm.handleClose
    }
  }, [_vm._v("\n            Cancelar\n          ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.step === 'code-input') ? _c('div', {
    staticClass: "code-input-step"
  }, [_c('p', {
    staticClass: "instruction-text"
  }, [_vm._v("\n            Digite o código de 6 dígitos que enviamos para o seu\n            " + _vm._s(_vm.selectedChannelLabel) + " para confirmar.\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "code-input-container"
  }, [_c('label', {
    staticClass: "code-label",
    attrs: {
      "for": "code-input-1"
    }
  }, [_vm._v("Digite o código de verificação")]), _vm._v(" "), _c('div', {
    staticClass: "code-input-boxes"
  }, _vm._l((6), function(n) {
    return _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.code[n - 1]),
        expression: "code[n - 1]"
      }],
      key: n,
      ref: ("codeInput" + n),
      refInFor: true,
      staticClass: "code-box",
      class: {
        'code-box-error': _vm.hasError
      },
      attrs: {
        "id": n === 1 ? 'code-input-1' : undefined,
        "type": "text",
        "maxlength": "1"
      },
      domProps: {
        "value": (_vm.code[n - 1])
      },
      on: {
        "input": [function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.code, n - 1, $event.target.value)
        }, function($event) {
          return _vm.handleCodeInput($event, n)
        }],
        "keydown": function($event) {
          return _vm.handleCodeKeydown($event, n)
        },
        "paste": function($event) {
          return _vm.handleCodePaste($event)
        }
      }
    })
  }), 0)]), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "error-message"
  }, [_vm._v("\n            " + _vm._s(_vm.errorMessage) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "resend-container"
  }, [_c('span', {
    staticClass: "resend-question"
  }, [_vm._v("Não recebeu o código?")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default resend-button",
    attrs: {
      "disabled": _vm.resendTimer > 0
    },
    on: {
      "click": _vm.handleResendClick
    }
  }, [(_vm.resendTimer > 0) ? _c('span', [_vm._v("Reenviar em " + _vm._s(_vm.resendTimer) + "s")]) : _c('span', [_vm._v("Reenviar")])])])]) : _vm._e()])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-442b1c98!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal-validate/modal-validate.vue
// module id = 2113
// module chunks = 1